console.log('OUTLAWS GLOBAL FIX ACTIVE 2026');

/* =========================================================
   FOCUSABLE ELEMENTS
========================================================= */

function getFocusableElements(container) {
  if (
    !container ||
    typeof container.querySelectorAll !== 'function'
  ) {
    console.warn(
      'OUTLAWS: getFocusableElements received invalid container',
      container
    );

    return [];
  }

  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


/* =========================================================
   SECTION ID
========================================================= */

class SectionId {
  static #separator = '__';

  static parseId(qualifiedSectionId) {
    if (!qualifiedSectionId) return '';

    return qualifiedSectionId.split(
      SectionId.#separator
    )[0];
  }

  static parseSectionName(qualifiedSectionId) {
    if (!qualifiedSectionId) return '';

    return qualifiedSectionId.split(
      SectionId.#separator
    )[1];
  }

  static getIdForSection(
    sectionId,
    sectionName
  ) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}


/* =========================================================
   HTML UPDATE UTILITY
========================================================= */

class HTMLUpdateUtility {
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    if (
      !oldNode ||
      !newContent
    ) {
      return;
    }

    preProcessCallbacks?.forEach(
      (callback) => {
        if (
          typeof callback === 'function'
        ) {
          callback(newContent);
        }
      }
    );

    const newNodeWrapper =
      document.createElement('div');

    HTMLUpdateUtility.setInnerHTML(
      newNodeWrapper,
      newContent.outerHTML
    );

    const newNode =
      newNodeWrapper.firstChild;

    if (!newNode) return;

    const uniqueKey =
      Date.now();

    oldNode
      .querySelectorAll('[id], [form]')
      .forEach((element) => {
        if (element.id) {
          element.id =
            `${element.id}-${uniqueKey}`;
        }

        if (element.form) {
          const formId =
            element.form.getAttribute(
              'id'
            );

          if (formId) {
            element.setAttribute(
              'form',
              `${formId}-${uniqueKey}`
            );
          }
        }
      });

    if (!oldNode.parentNode) {
      return;
    }

    oldNode.parentNode.insertBefore(
      newNode,
      oldNode
    );

    oldNode.style.display =
      'none';

    postProcessCallbacks?.forEach(
      (callback) => {
        if (
          typeof callback === 'function'
        ) {
          callback(newNode);
        }
      }
    );

    setTimeout(() => {
      oldNode.remove();
    }, 500);
  }

  static setInnerHTML(
    element,
    html
  ) {
    if (!element) return;

    element.innerHTML =
      html;

    element
      .querySelectorAll('script')
      .forEach((oldScriptTag) => {
        const newScriptTag =
          document.createElement(
            'script'
          );

        Array.from(
          oldScriptTag.attributes
        ).forEach((attribute) => {
          newScriptTag.setAttribute(
            attribute.name,
            attribute.value
          );
        });

        newScriptTag.appendChild(
          document.createTextNode(
            oldScriptTag.innerHTML
          )
        );

        if (
          oldScriptTag.parentNode
        ) {
          oldScriptTag.parentNode.replaceChild(
            newScriptTag,
            oldScriptTag
          );
        }
      });
  }
}


/* =========================================================
   DETAILS / ACCORDIONS
========================================================= */

document
  .querySelectorAll(
    '[id^="Details-"] summary'
  )
  .forEach((summary) => {
    summary.setAttribute(
      'role',
      'button'
    );

    summary.setAttribute(
      'aria-expanded',
      summary.parentNode?.hasAttribute(
        'open'
      )
        ? 'true'
        : 'false'
    );

    const nextElement =
      summary.nextElementSibling;

    if (
      nextElement &&
      nextElement.getAttribute('id')
    ) {
      summary.setAttribute(
        'aria-controls',
        nextElement.id
      );
    }

    summary.addEventListener(
      'click',
      (event) => {
        const details =
          event.currentTarget.closest(
            'details'
          );

        if (!details) return;

        event.currentTarget.setAttribute(
          'aria-expanded',
          details.hasAttribute('open')
            ? 'false'
            : 'true'
        );
      }
    );

    if (
      summary.closest(
        'header-drawer, menu-drawer'
      )
    ) {
      return;
    }

    if (summary.parentElement) {
      summary.parentElement.addEventListener(
        'keyup',
        onKeyUpEscape
      );
    }
  });


/* =========================================================
   FOCUS TRAP
========================================================= */

const trapFocusHandlers = {};


function trapFocus(
  container,
  elementToFocus = container
) {
  /*
   * CRITICAL CART FIX
   *
   * When cart goes:
   *
   * 0 items -> first item
   *
   * Dawn can briefly request focus on
   * .drawer__inner-empty even though
   * that element has already disappeared.
   */
  if (
    !container ||
    typeof container.querySelectorAll !==
      'function'
  ) {
    console.warn(
      'OUTLAWS: trapFocus skipped because container is invalid',
      container
    );

    if (
      elementToFocus &&
      typeof elementToFocus.focus ===
        'function'
    ) {
      try {
        elementToFocus.focus();
      } catch (error) {
        // Ignore focus failure
      }
    }

    return;
  }


  const elements =
    getFocusableElements(
      container
    );

  const first =
    elements.length
      ? elements[0]
      : null;

  const last =
    elements.length
      ? elements[
          elements.length - 1
        ]
      : null;


  removeTrapFocus();


  /*
   * Container exists but has no
   * focusable children.
   */
  if (!first || !last) {
    if (
      elementToFocus &&
      typeof elementToFocus.focus ===
        'function'
    ) {
      try {
        elementToFocus.focus();
      } catch (error) {
        // Ignore
      }
    }

    return;
  }


  trapFocusHandlers.focusin =
    (event) => {
      if (
        event.target !==
          container &&
        event.target !== last &&
        event.target !== first
      ) {
        return;
      }

      document.addEventListener(
        'keydown',
        trapFocusHandlers.keydown
      );
    };


  trapFocusHandlers.focusout =
    function () {
      document.removeEventListener(
        'keydown',
        trapFocusHandlers.keydown
      );
    };


  trapFocusHandlers.keydown =
    function (event) {
      if (
        event.code.toUpperCase() !==
        'TAB'
      ) {
        return;
      }

      /*
       * Last item + TAB
       */
      if (
        event.target === last &&
        !event.shiftKey
      ) {
        event.preventDefault();

        first.focus();

        return;
      }

      /*
       * First item + SHIFT TAB
       */
      if (
        (
          event.target ===
            container ||
          event.target === first
        ) &&
        event.shiftKey
      ) {
        event.preventDefault();

        last.focus();
      }
    };


  document.addEventListener(
    'focusout',
    trapFocusHandlers.focusout
  );

  document.addEventListener(
    'focusin',
    trapFocusHandlers.focusin
  );


  const target =
    elementToFocus &&
    typeof elementToFocus.focus ===
      'function'
      ? elementToFocus
      : first;


  if (target) {
    try {
      target.focus();
    } catch (error) {
      console.warn(
        'OUTLAWS: focus failed',
        error
      );
    }
  }


  if (
    target &&
    target.tagName === 'INPUT' &&
    [
      'search',
      'text',
      'email',
      'url'
    ].includes(target.type) &&
    target.value &&
    typeof target.setSelectionRange ===
      'function'
  ) {
    target.setSelectionRange(
      0,
      target.value.length
    );
  }
}


function removeTrapFocus(
  elementToFocus = null
) {
  if (
    trapFocusHandlers.focusin
  ) {
    document.removeEventListener(
      'focusin',
      trapFocusHandlers.focusin
    );
  }

  if (
    trapFocusHandlers.focusout
  ) {
    document.removeEventListener(
      'focusout',
      trapFocusHandlers.focusout
    );
  }

  if (
    trapFocusHandlers.keydown
  ) {
    document.removeEventListener(
      'keydown',
      trapFocusHandlers.keydown
    );
  }


  if (
    elementToFocus &&
    typeof elementToFocus.focus ===
      'function'
  ) {
    try {
      elementToFocus.focus();
    } catch (error) {
      // Ignore
    }
  }
}


/* =========================================================
   FOCUS VISIBLE
========================================================= */

try {
  document.querySelector(
    ':focus-visible'
  );
} catch (e) {
  focusVisiblePolyfill();
}


function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN'
  ];

  let currentFocusedElement =
    null;

  let mouseClick =
    null;


  window.addEventListener(
    'keydown',
    (event) => {
      if (
        navKeys.includes(
          event.code.toUpperCase()
        )
      ) {
        mouseClick = false;
      }
    }
  );


  window.addEventListener(
    'mousedown',
    () => {
      mouseClick = true;
    }
  );


  window.addEventListener(
    'focus',
    () => {
      if (
        currentFocusedElement
      ) {
        currentFocusedElement.classList.remove(
          'focused'
        );
      }

      if (mouseClick) {
        return;
      }

      currentFocusedElement =
        document.activeElement;

      if (
        currentFocusedElement &&
        currentFocusedElement.classList
      ) {
        currentFocusedElement.classList.add(
          'focused'
        );
      }
    },
    true
  );
}


/* =========================================================
   MEDIA
========================================================= */

function pauseAllMedia() {
  document
    .querySelectorAll(
      '.js-youtube'
    )
    .forEach((video) => {
      if (
        video.contentWindow
      ) {
        video.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
      }
    });


  document
    .querySelectorAll(
      '.js-vimeo'
    )
    .forEach((video) => {
      if (
        video.contentWindow
      ) {
        video.contentWindow.postMessage(
          '{"method":"pause"}',
          '*'
        );
      }
    });


  document
    .querySelectorAll('video')
    .forEach((video) => {
      try {
        video.pause();
      } catch (error) {
        // Ignore
      }
    });


  document
    .querySelectorAll(
      'product-model'
    )
    .forEach((model) => {
      if (
        model.modelViewerUI &&
        typeof model.modelViewerUI
          .pause === 'function'
      ) {
        model.modelViewerUI.pause();
      }
    });
}


window.pauseAllMedia =
  pauseAllMedia;


/* =========================================================
   ESCAPE
========================================================= */

function onKeyUpEscape(event) {
  if (
    event.code.toUpperCase() !==
    'ESCAPE'
  ) {
    return;
  }


  const openDetailsElement =
    event.target.closest(
      'details[open]'
    );


  if (!openDetailsElement) {
    return;
  }


  const summaryElement =
    openDetailsElement.querySelector(
      'summary'
    );


  openDetailsElement.removeAttribute(
    'open'
  );


  if (summaryElement) {
    summaryElement.setAttribute(
      'aria-expanded',
      'false'
    );

    summaryElement.focus();
  }
}


/* =========================================================
   QUANTITY INPUT
========================================================= */

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input =
      this.querySelector(
        'input'
      );

    this.changeEvent =
      new Event(
        'change',
        {
          bubbles: true
        }
      );


    if (!this.input) {
      return;
    }


    this.input.addEventListener(
      'change',
      this.onInputChange.bind(
        this
      )
    );


    this.querySelectorAll(
      'button'
    ).forEach((button) => {
      button.addEventListener(
        'click',
        this.onButtonClick.bind(
          this
        )
      );
    });
  }


  quantityUpdateUnsubscriber =
    undefined;


  connectedCallback() {
    if (!this.input) return;

    this.validateQtyRules();


    if (
      typeof subscribe ===
        'function' &&
      typeof PUB_SUB_EVENTS !==
        'undefined' &&
      PUB_SUB_EVENTS.quantityUpdate
    ) {
      this.quantityUpdateUnsubscriber =
        subscribe(
          PUB_SUB_EVENTS.quantityUpdate,
          this.validateQtyRules.bind(
            this
          )
        );
    }
  }


  disconnectedCallback() {
    if (
      this.quantityUpdateUnsubscriber
    ) {
      this.quantityUpdateUnsubscriber();
    }
  }


  onInputChange() {
    this.validateQtyRules();
  }


  onButtonClick(event) {
    event.preventDefault();

    if (!this.input) return;


    const button =
      event.currentTarget;


    const previousValue =
      this.input.value;


    if (
      button.name ===
      'plus'
    ) {
      if (
        parseInt(
          this.input.dataset.min
        ) >
          parseInt(
            this.input.step
          ) &&
        this.input.value == 0
      ) {
        this.input.value =
          this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }


    if (
      previousValue !==
      this.input.value
    ) {
      this.input.dispatchEvent(
        this.changeEvent
      );
    }


    if (
      this.input.dataset.min ===
        previousValue &&
      button.name ===
        'minus'
    ) {
      this.input.value =
        parseInt(
          this.input.min
        );
    }
  }


  validateQtyRules() {
    if (!this.input) return;


    const value =
      parseInt(
        this.input.value
      );


    if (
      this.input.min
    ) {
      const buttonMinus =
        this.querySelector(
          ".quantity__button[name='minus']"
        );


      if (buttonMinus) {
        buttonMinus.classList.toggle(
          'disabled',
          value <=
            parseInt(
              this.input.min
            )
        );
      }
    }


    if (
      this.input.max
    ) {
      const max =
        parseInt(
          this.input.max
        );


      const buttonPlus =
        this.querySelector(
          ".quantity__button[name='plus']"
        );


      if (buttonPlus) {
        buttonPlus.classList.toggle(
          'disabled',
          value >= max
        );
      }
    }
  }
}


if (
  !customElements.get(
    'quantity-input'
  )
) {
  customElements.define(
    'quantity-input',
    QuantityInput
  );
}


/* =========================================================
   HELPERS
========================================================= */

function debounce(
  fn,
  wait
) {
  let t;

  return (...args) => {
    clearTimeout(t);

    t = setTimeout(
      () => {
        fn.apply(
          this,
          args
        );
      },
      wait
    );
  };
}


function throttle(
  fn,
  delay
) {
  let lastCall = 0;

  return function (...args) {
    const now =
      Date.now();

    if (
      now - lastCall <
      delay
    ) {
      return;
    }

    lastCall = now;

    return fn(...args);
  };
}


function fetchConfig(
  type = 'json'
) {
  return {
    method: 'POST',

    headers: {
      'Content-Type':
        'application/json',

      Accept:
        `application/${type}`
    }
  };
}


/* =========================================================
   SHOPIFY COMMON JS
========================================================= */

if (
  typeof window.Shopify ===
  'undefined'
) {
  window.Shopify = {};
}


Shopify.bind =
  function (fn, scope) {
    return function () {
      return fn.apply(
        scope,
        arguments
      );
    };
  };


Shopify.setSelectorByValue =
  function (
    selector,
    value
  ) {
    if (!selector) return;


    for (
      let i = 0;
      i <
      selector.options.length;
      i++
    ) {
      const option =
        selector.options[i];


      if (
        value ==
          option.value ||
        value ==
          option.innerHTML
      ) {
        selector.selectedIndex =
          i;

        return i;
      }
    }
  };


Shopify.addListener =
  function (
    target,
    eventName,
    callback
  ) {
    if (!target) return;


    if (
      target.addEventListener
    ) {
      target.addEventListener(
        eventName,
        callback,
        false
      );
    } else if (
      target.attachEvent
    ) {
      target.attachEvent(
        'on' + eventName,
        callback
      );
    }
  };


Shopify.postLink =
  function (
    path,
    options
  ) {
    options =
      options || {};


    const method =
      options.method ||
      'post';


    const params =
      options.parameters ||
      {};


    const form =
      document.createElement(
        'form'
      );


    form.setAttribute(
      'method',
      method
    );


    form.setAttribute(
      'action',
      path
    );


    for (
      const key in params
    ) {
      const hiddenField =
        document.createElement(
          'input'
        );


      hiddenField.setAttribute(
        'type',
        'hidden'
      );


      hiddenField.setAttribute(
        'name',
        key
      );


      hiddenField.setAttribute(
        'value',
        params[key]
      );


      form.appendChild(
        hiddenField
      );
    }


    document.body.appendChild(
      form
    );


    form.submit();


    document.body.removeChild(
      form
    );
  };


Shopify.CountryProvinceSelector =
  function (
    country_domid,
    province_domid,
    options
  ) {
    this.countryEl =
      document.getElementById(
        country_domid
      );


    this.provinceEl =
      document.getElementById(
        province_domid
      );


    this.provinceContainer =
      document.getElementById(
        options?.hideElement ||
          province_domid
      );


    if (
      !this.countryEl ||
      !this.provinceEl
    ) {
      return;
    }


    Shopify.addListener(
      this.countryEl,
      'change',
      Shopify.bind(
        this.countryHandler,
        this
      )
    );


    this.initCountry();
    this.initProvince();
  };


Shopify.CountryProvinceSelector.prototype =
  {
    initCountry:
      function () {
        if (
          !this.countryEl
        ) {
          return;
        }


        const value =
          this.countryEl.getAttribute(
            'data-default'
          );


        Shopify.setSelectorByValue(
          this.countryEl,
          value
        );


        this.countryHandler();
      },


    initProvince:
      function () {
        if (
          !this.provinceEl
        ) {
          return;
        }


        const value =
          this.provinceEl.getAttribute(
            'data-default'
          );


        if (
          value &&
          this.provinceEl.options
            .length > 0
        ) {
          Shopify.setSelectorByValue(
            this.provinceEl,
            value
          );
        }
      },


    countryHandler:
      function () {
        if (
          !this.countryEl ||
          !this.provinceEl
        ) {
          return;
        }


        const opt =
          this.countryEl.options[
            this.countryEl
              .selectedIndex
          ];


        if (!opt) return;


        const raw =
          opt.getAttribute(
            'data-provinces'
          );


        let provinces = [];


        try {
          provinces =
            JSON.parse(
              raw || '[]'
            );
        } catch (error) {
          provinces = [];
        }


        this.clearOptions(
          this.provinceEl
        );


        if (
          !provinces ||
          provinces.length === 0
        ) {
          if (
            this.provinceContainer
          ) {
            this.provinceContainer.style.display =
              'none';
          }
        } else {
          for (
            let i = 0;
            i <
            provinces.length;
            i++
          ) {
            const option =
              document.createElement(
                'option'
              );


            option.value =
              provinces[i][0];


            option.innerHTML =
              provinces[i][1];


            this.provinceEl.appendChild(
              option
            );
          }


          if (
            this.provinceContainer
          ) {
            this.provinceContainer.style.display =
              '';
          }
        }
      },


    clearOptions:
      function (selector) {
        if (!selector) return;


        while (
          selector.firstChild
        ) {
          selector.removeChild(
            selector.firstChild
          );
        }
      },


    setOptions:
      function (
        selector,
        values
      ) {
        if (!selector) return;


        for (
          let i = 0;
          i < values.length;
          i++
        ) {
          const opt =
            document.createElement(
              'option'
            );


          opt.value =
            values[i];


          opt.innerHTML =
            values[i];


          selector.appendChild(
            opt
          );
        }
      }
  };


/* =========================================================
   MENU DRAWER
========================================================= */

class MenuDrawer extends HTMLElement {
  constructor() {
    super();


    this.mainDetailsToggle =
      this.querySelector(
        'details'
      );


    this.addEventListener(
      'keyup',
      this.onKeyUp.bind(
        this
      )
    );


    this.addEventListener(
      'focusout',
      this.onFocusOut.bind(
        this
      )
    );


    this.bindEvents();
  }


  bindEvents() {
    this.querySelectorAll(
      'summary'
    ).forEach((summary) => {
      summary.addEventListener(
        'click',
        this.onSummaryClick.bind(
          this
        )
      );
    });


    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => {
      button.addEventListener(
        'click',
        this.onCloseButtonClick.bind(
          this
        )
      );
    });
  }


  onKeyUp(event) {
    if (
      event.code.toUpperCase() !==
      'ESCAPE'
    ) {
      return;
    }


    const openDetailsElement =
      event.target.closest(
        'details[open]'
      );


    if (!openDetailsElement) {
      return;
    }


    if (
      openDetailsElement ===
      this.mainDetailsToggle
    ) {
      this.closeMenuDrawer(
        event,
        this.mainDetailsToggle?.querySelector(
          'summary'
        )
      );
    } else {
      this.closeSubmenu(
        openDetailsElement
      );
    }
  }


  onSummaryClick(event) {
    const summaryElement =
      event.currentTarget;


    const detailsElement =
      summaryElement.parentNode;


    if (!detailsElement) {
      return;
    }


    const parentMenuElement =
      detailsElement.closest(
        '.has-submenu'
      );


    const isOpen =
      detailsElement.hasAttribute(
        'open'
      );


    const reducedMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );


    const addTrapFocus =
      () => {
        const container =
          summaryElement.nextElementSibling;


        const button =
          detailsElement.querySelector(
            'button'
          );


        if (
          container &&
          button
        ) {
          trapFocus(
            container,
            button
          );
        }


        container?.removeEventListener(
          'transitionend',
          addTrapFocus
        );
      };


    if (
      detailsElement ===
      this.mainDetailsToggle
    ) {
      if (isOpen) {
        event.preventDefault();
      }


      if (isOpen) {
        this.closeMenuDrawer(
          event,
          summaryElement
        );
      } else {
        this.openMenuDrawer(
          summaryElement
        );
      }


      if (
        window.matchMedia(
          '(max-width: 990px)'
        ).matches
      ) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add(
          'menu-opening'
        );


        summaryElement.setAttribute(
          'aria-expanded',
          'true'
        );


        parentMenuElement?.classList.add(
          'submenu-open'
        );


        if (
          reducedMotion.matches
        ) {
          addTrapFocus();
        } else if (
          summaryElement.nextElementSibling
        ) {
          summaryElement.nextElementSibling.addEventListener(
            'transitionend',
            addTrapFocus
          );
        }
      }, 100);
    }
  }


  openMenuDrawer(
    summaryElement
  ) {
    if (
      !this.mainDetailsToggle ||
      !summaryElement
    ) {
      return;
    }


    setTimeout(() => {
      this.mainDetailsToggle.classList.add(
        'menu-opening'
      );
    });


    summaryElement.setAttribute(
      'aria-expanded',
      'true'
    );


    trapFocus(
      this.mainDetailsToggle,
      summaryElement
    );


    document.body.classList.add(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
  }


  closeMenuDrawer(
    event,
    elementToFocus = false
  ) {
    if (
      event === undefined ||
      !this.mainDetailsToggle
    ) {
      return;
    }


    this.mainDetailsToggle.classList.remove(
      'menu-opening'
    );


    this.mainDetailsToggle
      .querySelectorAll(
        'details'
      )
      .forEach((details) => {
        details.removeAttribute(
          'open'
        );


        details.classList.remove(
          'menu-opening'
        );
      });


    this.mainDetailsToggle
      .querySelectorAll(
        '.submenu-open'
      )
      .forEach((submenu) => {
        submenu.classList.remove(
          'submenu-open'
        );
      });


    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );


    removeTrapFocus(
      elementToFocus
    );


    this.closeAnimation(
      this.mainDetailsToggle
    );


    if (
      event instanceof
        KeyboardEvent &&
      elementToFocus
    ) {
      elementToFocus.setAttribute(
        'aria-expanded',
        'false'
      );
    }
  }


  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle?.hasAttribute(
          'open'
        ) &&
        !this.mainDetailsToggle.contains(
          document.activeElement
        )
      ) {
        /*
         * Keep original Dawn behaviour.
         */
        this.closeMenuDrawer();
      }
    });
  }


  onCloseButtonClick(event) {
    const detailsElement =
      event.currentTarget.closest(
        'details'
      );


    if (detailsElement) {
      this.closeSubmenu(
        detailsElement
      );
    }
  }


  closeSubmenu(
    detailsElement
  ) {
    if (!detailsElement) {
      return;
    }


    const parentMenuElement =
      detailsElement.closest(
        '.submenu-open'
      );


    parentMenuElement?.classList.remove(
      'submenu-open'
    );


    detailsElement.classList.remove(
      'menu-opening'
    );


    const summary =
      detailsElement.querySelector(
        'summary'
      );


    if (summary) {
      summary.setAttribute(
        'aria-expanded',
        'false'
      );
    }


    removeTrapFocus(
      summary
    );


    this.closeAnimation(
      detailsElement
    );
  }


  closeAnimation(
    detailsElement
  ) {
    if (!detailsElement) {
      return;
    }


    let animationStart;


    const handleAnimation =
      (time) => {
        if (
          animationStart ===
          undefined
        ) {
          animationStart =
            time;
        }


        const elapsedTime =
          time -
          animationStart;


        if (
          elapsedTime <
          400
        ) {
          window.requestAnimationFrame(
            handleAnimation
          );
        } else {
          detailsElement.removeAttribute(
            'open'
          );


          const parentDetails =
            detailsElement.closest(
              'details[open]'
            );


          const summary =
            detailsElement.querySelector(
              'summary'
            );


          if (
            parentDetails &&
            summary
          ) {
            trapFocus(
              parentDetails,
              summary
            );
          }
        }
      };


    window.requestAnimationFrame(
      handleAnimation
    );
  }
}


if (
  !customElements.get(
    'menu-drawer'
  )
) {
  customElements.define(
    'menu-drawer',
    MenuDrawer
  );
}


/* =========================================================
   HEADER DRAWER
========================================================= */

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }


  openMenuDrawer(
    summaryElement
  ) {
    if (!summaryElement) {
      return;
    }


    this.header =
      this.header ||
      document.querySelector(
        '.section-header'
      );


    const wrapper =
      this.closest(
        '.header-wrapper'
      );


    this.borderOffset =
      wrapper?.classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0;


    if (this.header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(
          this.header.getBoundingClientRect()
            .bottom -
            this.borderOffset
        )}px`
      );


      this.header.classList.add(
        'menu-open'
      );
    }


    setTimeout(() => {
      this.mainDetailsToggle?.classList.add(
        'menu-opening'
      );
    });


    summaryElement.setAttribute(
      'aria-expanded',
      'true'
    );


    window.addEventListener(
      'resize',
      this.onResize
    );


    if (
      this.mainDetailsToggle
    ) {
      trapFocus(
        this.mainDetailsToggle,
        summaryElement
      );
    }


    document.body.classList.add(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
  }


  closeMenuDrawer(
    event,
    elementToFocus
  ) {
    if (!elementToFocus) {
      return;
    }


    super.closeMenuDrawer(
      event,
      elementToFocus
    );


    this.header?.classList.remove(
      'menu-open'
    );


    window.removeEventListener(
      'resize',
      this.onResize
    );
  }


  onResize = () => {
    if (this.header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(
          this.header.getBoundingClientRect()
            .bottom -
            this.borderOffset
        )}px`
      );
    }


    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`
    );
  };
}


if (
  !customElements.get(
    'header-drawer'
  )
) {
  customElements.define(
    'header-drawer',
    HeaderDrawer
  );
}


/* =========================================================
   MODAL DIALOG
========================================================= */

class ModalDialog extends HTMLElement {
  constructor() {
    super();


    const closeButton =
      this.querySelector(
        '[id^="ModalClose-"]'
      );


    if (closeButton) {
      closeButton.addEventListener(
        'click',
        this.hide.bind(
          this,
          false
        )
      );
    }


    this.addEventListener(
      'keyup',
      (event) => {
        if (
          event.code.toUpperCase() ===
          'ESCAPE'
        ) {
          this.hide();
        }
      }
    );


    if (
      this.classList.contains(
        'media-modal'
      )
    ) {
      this.addEventListener(
        'pointerup',
        (event) => {
          if (
            event.pointerType ===
              'mouse' &&
            !event.target.closest(
              'deferred-media, product-model'
            )
          ) {
            this.hide();
          }
        }
      );
    } else {
      this.addEventListener(
        'click',
        (event) => {
          if (
            event.target === this
          ) {
            this.hide();
          }
        }
      );
    }
  }


  connectedCallback() {
    if (this.moved) {
      return;
    }


    this.moved =
      true;


    const section =
      this.closest(
        '.shopify-section'
      );


    if (section?.id) {
      this.dataset.section =
        section.id.replace(
          'shopify-section-',
          ''
        );
    }


    document.body.appendChild(
      this
    );
  }


  show(opener) {
    this.openedBy =
      opener;


    const popup =
      this.querySelector(
        '.template-popup'
      );


    document.body.classList.add(
      'overflow-hidden'
    );


    this.setAttribute(
      'open',
      ''
    );


    if (
      popup &&
      typeof popup.loadContent ===
        'function'
    ) {
      popup.loadContent();
    }


    const dialog =
      this.querySelector(
        '[role="dialog"]'
      );


    trapFocus(
      this,
      dialog || this
    );


    window.pauseAllMedia();
  }


  hide() {
    document.body.classList.remove(
      'overflow-hidden'
    );


    document.body.dispatchEvent(
      new CustomEvent(
        'modalClosed'
      )
    );


    this.removeAttribute(
      'open'
    );


    removeTrapFocus(
      this.openedBy
    );


    window.pauseAllMedia();
  }
}


if (
  !customElements.get(
    'modal-dialog'
  )
) {
  customElements.define(
    'modal-dialog',
    ModalDialog
  );
}


/* =========================================================
   BULK MODAL
========================================================= */

class BulkModal extends HTMLElement {
  connectedCallback() {
    const target =
      document.querySelector(
        `#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`
      );


    if (!target) {
      return;
    }


    const handleIntersection =
      (
        entries,
        observer
      ) => {
        if (
          !entries[0]
            ?.isIntersecting
        ) {
          return;
        }


        observer.unobserve(
          this
        );


        if (
          this.innerHTML.trim() !==
          ''
        ) {
          return;
        }


        if (!this.dataset.url) {
          return;
        }


        const productUrl =
          this.dataset.url.split(
            '?'
          )[0];


        fetch(
          `${productUrl}?section_id=bulk-quick-order-list`
        )
          .then(
            (response) =>
              response.text()
          )
          .then(
            (responseText) => {
              const html =
                new DOMParser().parseFromString(
                  responseText,
                  'text/html'
                );


              const source =
                html.querySelector(
                  '.quick-order-list-container'
                );


              if (
                source?.parentNode
              ) {
                this.innerHTML =
                  source.parentNode.innerHTML;
              }
            }
          )
          .catch(
            (error) => {
              console.error(
                error
              );
            }
          );
      };


    new IntersectionObserver(
      handleIntersection.bind(
        this
      )
    ).observe(
      target
    );
  }
}


if (
  !customElements.get(
    'bulk-modal'
  )
) {
  customElements.define(
    'bulk-modal',
    BulkModal
  );
}


/* =========================================================
   MODAL OPENER
========================================================= */

class ModalOpener extends HTMLElement {
  constructor() {
    super();


    const button =
      this.querySelector(
        'button'
      );


    if (!button) {
      return;
    }


    button.addEventListener(
      'click',
      () => {
        const selector =
          this.getAttribute(
            'data-modal'
          );


        if (!selector) {
          return;
        }


        const modal =
          document.querySelector(
            selector
          );


        if (
          modal &&
          typeof modal.show ===
            'function'
        ) {
          modal.show(
            button
          );
        }
      }
    );
  }
}


if (
  !customElements.get(
    'modal-opener'
  )
) {
  customElements.define(
    'modal-opener',
    ModalOpener
  );
}


/* =========================================================
   DEFERRED MEDIA
========================================================= */

class DeferredMedia extends HTMLElement {
  constructor() {
    super();


    const poster =
      this.querySelector(
        '[id^="Deferred-Poster-"]'
      );


    if (!poster) {
      return;
    }


    poster.addEventListener(
      'click',
      this.loadContent.bind(
        this
      )
    );
  }


  loadContent(
    focus = true
  ) {
    window.pauseAllMedia();


    if (
      this.getAttribute(
        'loaded'
      )
    ) {
      return;
    }


    const template =
      this.querySelector(
        'template'
      );


    if (
      !template?.content
        ?.firstElementChild
    ) {
      return;
    }


    const content =
      document.createElement(
        'div'
      );


    content.appendChild(
      template.content.firstElementChild.cloneNode(
        true
      )
    );


    const media =
      content.querySelector(
        'video, model-viewer, iframe'
      );


    if (!media) {
      return;
    }


    this.setAttribute(
      'loaded',
      'true'
    );


    const deferredElement =
      this.appendChild(
        media
      );


    if (
      focus &&
      typeof deferredElement.focus ===
        'function'
    ) {
      deferredElement.focus();
    }


    if (
      deferredElement.nodeName ===
        'VIDEO' &&
      deferredElement.getAttribute(
        'autoplay'
      )
    ) {
      deferredElement
        .play()
        .catch(() => {});
    }


    const formerStyle =
      deferredElement.getAttribute(
        'style'
      );


    deferredElement.setAttribute(
      'style',
      'display: block;'
    );


    window.setTimeout(
      () => {
        if (
          formerStyle === null
        ) {
          deferredElement.removeAttribute(
            'style'
          );
        } else {
          deferredElement.setAttribute(
            'style',
            formerStyle
          );
        }
      },
      0
    );
  }
}


if (
  !customElements.get(
    'deferred-media'
  )
) {
  customElements.define(
    'deferred-media',
    DeferredMedia
  );
}


/* =========================================================
   SLIDER COMPONENT
========================================================= */

class SliderComponent extends HTMLElement {
  constructor() {
    super();


    this.slider =
      this.querySelector(
        '[id^="Slider-"]'
      );


    this.sliderItems =
      this.querySelectorAll(
        '[id^="Slide-"]'
      );


    this.enableSliderLooping =
      false;


    this.currentPageElement =
      this.querySelector(
        '.slider-counter--current'
      );


    this.pageTotalElement =
      this.querySelector(
        '.slider-counter--total'
      );


    this.prevButton =
      this.querySelector(
        'button[name="previous"]'
      );


    this.nextButton =
      this.querySelector(
        'button[name="next"]'
      );


    if (
      !this.slider ||
      !this.nextButton
    ) {
      return;
    }


    this.initPages();


    const resizeObserver =
      new ResizeObserver(
        () => {
          this.initPages();
        }
      );


    resizeObserver.observe(
      this.slider
    );


    this.slider.addEventListener(
      'scroll',
      this.update.bind(
        this
      )
    );


    this.prevButton?.addEventListener(
      'click',
      this.onButtonClick.bind(
        this
      )
    );


    this.nextButton.addEventListener(
      'click',
      this.onButtonClick.bind(
        this
      )
    );
  }


  initPages() {
    if (!this.slider) {
      return;
    }


    this.sliderItemsToShow =
      Array.from(
        this.sliderItems
      ).filter(
        (element) =>
          element.clientWidth > 0
      );


    if (
      this.sliderItemsToShow.length <
      2
    ) {
      return;
    }


    this.sliderItemOffset =
      this.sliderItemsToShow[1]
        .offsetLeft -
      this.sliderItemsToShow[0]
        .offsetLeft;


    if (
      !this.sliderItemOffset
    ) {
      return;
    }


    this.slidesPerPage =
      Math.floor(
        (
          this.slider.clientWidth -
          this.sliderItemsToShow[0]
            .offsetLeft
        ) /
          this.sliderItemOffset
      );


    this.totalPages =
      this.sliderItemsToShow.length -
      this.slidesPerPage +
      1;


    this.update();
  }


  resetPages() {
    this.sliderItems =
      this.querySelectorAll(
        '[id^="Slide-"]'
      );


    this.initPages();
  }


  update() {
    if (
      !this.slider ||
      !this.nextButton ||
      !this.sliderItemOffset ||
      !this.sliderItemsToShow
        ?.length
    ) {
      return;
    }


    const previousPage =
      this.currentPage;


    this.currentPage =
      Math.round(
        this.slider.scrollLeft /
          this.sliderItemOffset
      ) + 1;


    if (
      this.currentPageElement &&
      this.pageTotalElement
    ) {
      this.currentPageElement.textContent =
        this.currentPage;


      this.pageTotalElement.textContent =
        this.totalPages;
    }


    if (
      this.currentPage !==
      previousPage
    ) {
      this.dispatchEvent(
        new CustomEvent(
          'slideChanged',
          {
            detail: {
              currentPage:
                this.currentPage,

              currentElement:
                this.sliderItemsToShow[
                  this.currentPage -
                    1
                ]
            }
          }
        )
      );
    }


    if (
      this.enableSliderLooping
    ) {
      return;
    }


    if (
      this.prevButton
    ) {
      if (
        this.isSlideVisible(
          this.sliderItemsToShow[0]
        ) &&
        this.slider.scrollLeft ===
          0
      ) {
        this.prevButton.setAttribute(
          'disabled',
          'disabled'
        );
      } else {
        this.prevButton.removeAttribute(
          'disabled'
        );
      }
    }


    if (
      this.isSlideVisible(
        this.sliderItemsToShow[
          this.sliderItemsToShow
            .length - 1
        ]
      )
    ) {
      this.nextButton.setAttribute(
        'disabled',
        'disabled'
      );
    } else {
      this.nextButton.removeAttribute(
        'disabled'
      );
    }
  }


  isSlideVisible(
    element,
    offset = 0
  ) {
    if (
      !element ||
      !this.slider
    ) {
      return false;
    }


    const lastVisibleSlide =
      this.slider.clientWidth +
      this.slider.scrollLeft -
      offset;


    return (
      element.offsetLeft +
        element.clientWidth <=
        lastVisibleSlide &&
      element.offsetLeft >=
        this.slider.scrollLeft
    );
  }


  onButtonClick(event) {
    event.preventDefault();


    if (
      !this.slider ||
      !this.sliderItemOffset
    ) {
      return;
    }


    const step =
      Number(
        event.currentTarget.dataset
          .step
      ) || 1;


    this.slideScrollPosition =
      event.currentTarget.name ===
      'next'
        ? this.slider.scrollLeft +
          step *
            this.sliderItemOffset
        : this.slider.scrollLeft -
          step *
            this.sliderItemOffset;


    this.setSlidePosition(
      this.slideScrollPosition
    );
  }


  setSlidePosition(
    position
  ) {
    this.slider?.scrollTo({
      left: position
    });
  }
}


if (
  !customElements.get(
    'slider-component'
  )
) {
  customElements.define(
    'slider-component',
    SliderComponent
  );
}


/* =========================================================
   SLIDESHOW
========================================================= */

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();


    this.sliderControlWrapper =
      this.querySelector(
        '.slider-buttons'
      );


    this.enableSliderLooping =
      true;


    if (
      !this.sliderControlWrapper ||
      !this.slider
    ) {
      return;
    }


    this.sliderFirstItemNode =
      this.slider.querySelector(
        '.slideshow__slide'
      );


    if (
      this.sliderItemsToShow
        ?.length > 0
    ) {
      this.currentPage =
        1;
    }


    this.announcementBarSlider =
      this.querySelector(
        '.announcement-bar-slider'
      );


    this.announcerBarAnimationDelay =
      this.announcementBarSlider
        ? 250
        : 0;


    this.sliderControlLinksArray =
      Array.from(
        this.sliderControlWrapper.querySelectorAll(
          '.slider-counter__link'
        )
      );


    this.sliderControlLinksArray.forEach(
      (link) => {
        link.addEventListener(
          'click',
          this.linkToSlide.bind(
            this
          )
        );
      }
    );


    this.slider.addEventListener(
      'scroll',
      this.setSlideVisibility.bind(
        this
      )
    );


    this.setSlideVisibility();


    if (
      this.announcementBarSlider
    ) {
      this.announcementBarArrowButtonWasClicked =
        false;


      this.reducedMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );


      this.reducedMotion.addEventListener(
        'change',
        () => {
          if (
            this.slider.getAttribute(
              'data-autoplay'
            ) === 'true'
          ) {
            this.setAutoPlay();
          }
        }
      );


      [
        this.prevButton,
        this.nextButton
      ]
        .filter(Boolean)
        .forEach((button) => {
          button.addEventListener(
            'click',
            () => {
              this.announcementBarArrowButtonWasClicked =
                true;
            },
            {
              once: true
            }
          );
        });
    }


    if (
      this.slider.getAttribute(
        'data-autoplay'
      ) === 'true'
    ) {
      this.setAutoPlay();
    }
  }


  setAutoPlay() {
    this.autoplaySpeed =
      Number(
        this.slider.dataset.speed
      ) * 1000;


    this.addEventListener(
      'mouseover',
      this.focusInHandling.bind(
        this
      )
    );


    this.addEventListener(
      'mouseleave',
      this.focusOutHandling.bind(
        this
      )
    );


    this.addEventListener(
      'focusin',
      this.focusInHandling.bind(
        this
      )
    );


    this.addEventListener(
      'focusout',
      this.focusOutHandling.bind(
        this
      )
    );


    if (
      this.querySelector(
        '.slideshow__autoplay'
      )
    ) {
      this.sliderAutoplayButton =
        this.querySelector(
          '.slideshow__autoplay'
        );


      this.sliderAutoplayButton.addEventListener(
        'click',
        this.autoPlayToggle.bind(
          this
        )
      );


      this.autoplayButtonIsSetToPlay =
        true;


      this.play();
    } else {
      if (
        this.reducedMotion
          ?.matches ||
        this.announcementBarArrowButtonWasClicked
      ) {
        this.pause();
      } else {
        this.play();
      }
    }
  }


  onButtonClick(event) {
    super.onButtonClick(
      event
    );


    this.wasClicked =
      true;


    if (
      !this.sliderItemsToShow
        ?.length ||
      !this.sliderFirstItemNode
    ) {
      return;
    }


    const isFirstSlide =
      this.currentPage === 1;


    const isLastSlide =
      this.currentPage ===
      this.sliderItemsToShow.length;


    if (
      !isFirstSlide &&
      !isLastSlide
    ) {
      this.applyAnimationToAnnouncementBar(
        event.currentTarget.name
      );

      return;
    }


    if (
      isFirstSlide &&
      event.currentTarget.name ===
        'previous'
    ) {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode
          .clientWidth *
          this.sliderItemsToShow
            .length;
    } else if (
      isLastSlide &&
      event.currentTarget.name ===
        'next'
    ) {
      this.slideScrollPosition =
        0;
    }


    this.setSlidePosition(
      this.slideScrollPosition
    );


    this.applyAnimationToAnnouncementBar(
      event.currentTarget.name
    );
  }


  setSlidePosition(position) {
    if (
      this.setPositionTimeout
    ) {
      clearTimeout(
        this.setPositionTimeout
      );
    }


    this.setPositionTimeout =
      setTimeout(() => {
        this.slider?.scrollTo({
          left: position
        });
      }, this.announcerBarAnimationDelay);
  }


  update() {
    super.update();


    if (!this.slider) {
      return;
    }


    this.sliderControlButtons =
      this.querySelectorAll(
        '.slider-counter__link'
      );


    this.prevButton?.removeAttribute(
      'disabled'
    );


    if (
      !this.sliderControlButtons.length
    ) {
      return;
    }


    this.sliderControlButtons.forEach(
      (link) => {
        link.classList.remove(
          'slider-counter__link--active'
        );


        link.removeAttribute(
          'aria-current'
        );
      }
    );


    const current =
      this.sliderControlButtons[
        this.currentPage - 1
      ];


    if (current) {
      current.classList.add(
        'slider-counter__link--active'
      );


      current.setAttribute(
        'aria-current',
        'true'
      );
    }
  }


  autoPlayToggle() {
    this.togglePlayButtonState(
      this.autoplayButtonIsSetToPlay
    );


    if (
      this.autoplayButtonIsSetToPlay
    ) {
      this.pause();
    } else {
      this.play();
    }


    this.autoplayButtonIsSetToPlay =
      !this.autoplayButtonIsSetToPlay;
  }


  focusOutHandling(event) {
    if (
      this.sliderAutoplayButton
    ) {
      const focusedOnAutoplayButton =
        event.target ===
          this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(
          event.target
        );


      if (
        !this.autoplayButtonIsSetToPlay ||
        focusedOnAutoplayButton
      ) {
        return;
      }


      this.play();

    } else if (
      this.reducedMotion &&
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }


  focusInHandling(event) {
    if (
      this.sliderAutoplayButton
    ) {
      const focusedOnAutoplayButton =
        event.target ===
          this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(
          event.target
        );


      if (
        focusedOnAutoplayButton &&
        this.autoplayButtonIsSetToPlay
      ) {
        this.play();
      } else if (
        this.autoplayButtonIsSetToPlay
      ) {
        this.pause();
      }

    } else if (
      this.announcementBarSlider?.contains(
        event.target
      )
    ) {
      this.pause();
    }
  }


  play() {
    if (!this.slider) {
      return;
    }


    this.slider.setAttribute(
      'aria-live',
      'off'
    );


    clearInterval(
      this.autoplay
    );


    this.autoplay =
      setInterval(
        this.autoRotateSlides.bind(
          this
        ),
        this.autoplaySpeed
      );
  }


  pause() {
    if (!this.slider) {
      return;
    }


    this.slider.setAttribute(
      'aria-live',
      'polite'
    );


    clearInterval(
      this.autoplay
    );
  }


  togglePlayButtonState(
    pauseAutoplay
  ) {
    if (
      !this.sliderAutoplayButton
    ) {
      return;
    }


    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add(
        'slideshow__autoplay--paused'
      );


      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings
          ?.playSlideshow ||
          'Play slideshow'
      );
    } else {
      this.sliderAutoplayButton.classList.remove(
        'slideshow__autoplay--paused'
      );


      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings
          ?.pauseSlideshow ||
          'Pause slideshow'
      );
    }
  }


  autoRotateSlides() {
    if (
      !this.sliderItems?.length ||
      !this.sliderItemOffset
    ) {
      return;
    }


    const slideScrollPosition =
      this.currentPage ===
      this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.sliderItemOffset;


    this.setSlidePosition(
      slideScrollPosition
    );


    this.applyAnimationToAnnouncementBar();
  }


  setSlideVisibility() {
    if (
      !this.sliderItemsToShow
        ?.length
    ) {
      return;
    }


    this.sliderItemsToShow.forEach(
      (item, index) => {
        const linkElements =
          item.querySelectorAll(
            'a'
          );


        if (
          index ===
          this.currentPage - 1
        ) {
          linkElements.forEach(
            (link) => {
              link.removeAttribute(
                'tabindex'
              );
            }
          );


          item.setAttribute(
            'aria-hidden',
            'false'
          );


          item.removeAttribute(
            'tabindex'
          );
        } else {
          linkElements.forEach(
            (link) => {
              link.setAttribute(
                'tabindex',
                '-1'
              );
            }
          );


          item.setAttribute(
            'aria-hidden',
            'true'
          );


          item.setAttribute(
            'tabindex',
            '-1'
          );
        }
      }
    );


    this.wasClicked =
      false;
  }


  applyAnimationToAnnouncementBar(
    button = 'next'
  ) {
    if (
      !this.announcementBarSlider ||
      !this.sliderItems?.length
    ) {
      return;
    }


    const itemsCount =
      this.sliderItems.length;


    const increment =
      button === 'next'
        ? 1
        : -1;


    const currentIndex =
      this.currentPage - 1;


    let nextIndex =
      (
        currentIndex +
        increment
      ) %
      itemsCount;


    nextIndex =
      nextIndex === -1
        ? itemsCount - 1
        : nextIndex;


    const nextSlide =
      this.sliderItems[
        nextIndex
      ];


    const currentSlide =
      this.sliderItems[
        currentIndex
      ];


    if (
      !nextSlide ||
      !currentSlide
    ) {
      return;
    }


    const animationClassIn =
      'announcement-bar-slider--fade-in';


    const animationClassOut =
      'announcement-bar-slider--fade-out';


    const isFirstSlide =
      currentIndex === 0;


    const isLastSlide =
      currentIndex ===
      itemsCount - 1;


    const shouldMoveNext =
      (
        button === 'next' &&
        !isLastSlide
      ) ||
      (
        button ===
          'previous' &&
        isFirstSlide
      );


    const direction =
      shouldMoveNext
        ? 'next'
        : 'previous';


    currentSlide.classList.add(
      `${animationClassOut}-${direction}`
    );


    nextSlide.classList.add(
      `${animationClassIn}-${direction}`
    );


    setTimeout(() => {
      currentSlide.classList.remove(
        `${animationClassOut}-${direction}`
      );


      nextSlide.classList.remove(
        `${animationClassIn}-${direction}`
      );
    }, this.announcerBarAnimationDelay * 2);
  }


  linkToSlide(event) {
    event.preventDefault();


    if (
      !this.slider ||
      !this.sliderFirstItemNode
    ) {
      return;
    }


    const index =
      this.sliderControlLinksArray.indexOf(
        event.currentTarget
      );


    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode
        .clientWidth *
        (
          index +
          1 -
          this.currentPage
        );


    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}


if (
  !customElements.get(
    'slideshow-component'
  )
) {
  customElements.define(
    'slideshow-component',
    SlideshowComponent
  );
}


/* =========================================================
   VARIANT SELECTS
========================================================= */

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }


  connectedCallback() {
    this.addEventListener(
      'change',
      (event) => {
        const target =
          this.getInputForEventTarget(
            event.target
          );


        this.updateSelectionMetadata(
          event
        );


        this.dispatchProductSelectEvent();


        if (
          typeof publish ===
            'function' &&
          typeof PUB_SUB_EVENTS !==
            'undefined' &&
          PUB_SUB_EVENTS.optionValueSelectionChange
        ) {
          publish(
            PUB_SUB_EVENTS.optionValueSelectionChange,
            {
              data: {
                event,
                target,
                selectedOptionValues:
                  this.selectedOptionValues
              }
            }
          );
        }
      }
    );
  }


  getAllSelectedOptions() {
    const options =
      [];


    this.querySelectorAll(
      'fieldset, .product-form__input--dropdown'
    ).forEach((group) => {
      const checked =
        group.querySelector(
          'input:checked'
        ) ||
        group.querySelector(
          'select option[selected]'
        );


      if (checked) {
        options.push({
          name:
            checked.dataset
              .optionName ||
            '',

          value:
            checked.value
        });
      }
    });


    return options;
  }


  dispatchProductSelectEvent() {
    const {
      ProductSelectEvent
    } =
      window.StandardEvents ||
      {};


    if (!ProductSelectEvent) {
      return;
    }


    const deferred =
      ProductSelectEvent.createPromise();


    this.pendingSelectPromise =
      deferred;


    this.dispatchEvent(
      new ProductSelectEvent({
        product: {
          id:
            this.dataset.productId,

          title:
            this.dataset.productTitle,

          handle:
            this.dataset.productHandle
        },

        selectedOptions:
          this.getAllSelectedOptions(),

        promise:
          deferred.promise
      })
    );
  }


  takePendingSelectPromise() {
    const deferred =
      this.pendingSelectPromise;


    this.pendingSelectPromise =
      null;


    return deferred;
  }


  resolvePendingSelectPromise(
    variant,
    sourceVariantSelects = this
  ) {
    const deferred =
      this.takePendingSelectPromise();


    if (!deferred) {
      return;
    }


    if (variant) {
      deferred.resolve({
        variant: {
          id:
            variant.id,

          title:
            variant.title,

          availableForSale:
            variant.available,

          price: {
            amount:
              sourceVariantSelects
                ?.dataset
                .selectedPriceAmount,

            currencyCode:
              sourceVariantSelects
                ?.dataset
                .currencyCode
          },

          selectedOptions:
            this.getAllSelectedOptions()
        }
      });
    } else {
      deferred.resolve({
        variant: null
      });
    }
  }


  rejectPendingSelectPromise(
    error
  ) {
    this.takePendingSelectPromise()
      ?.reject(
        error
      );
  }


  updateSelectionMetadata({
    target
  }) {
    if (!target) {
      return;
    }


    const {
      value,
      tagName
    } =
      target;


    if (
      tagName === 'SELECT' &&
      target.selectedOptions
        .length
    ) {
      const oldSelected =
        Array.from(
          target.options
        ).find((option) =>
          option.hasAttribute(
            'selected'
          )
        );


      oldSelected?.removeAttribute(
        'selected'
      );


      target.selectedOptions[0].setAttribute(
        'selected',
        'selected'
      );


      const swatchValue =
        target.selectedOptions[0]
          .dataset
          .optionSwatchValue;


      const container =
        target.closest(
          '.product-form__input'
        );


      const selectedDropdownSwatchValue =
        container?.querySelector(
          '[data-selected-value] > .swatch'
        );


      if (
        !selectedDropdownSwatchValue
      ) {
        return;
      }


      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          '--swatch--background',
          swatchValue
        );


        selectedDropdownSwatchValue.classList.remove(
          'swatch--unavailable'
        );
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          '--swatch--background',
          'unset'
        );


        selectedDropdownSwatchValue.classList.add(
          'swatch--unavailable'
        );
      }


      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0]
          .dataset
          .optionSwatchFocalPoint ||
          'unset'
      );

    } else if (
      tagName === 'INPUT' &&
      target.type === 'radio'
    ) {
      const container =
        target.closest(
          '.product-form__input'
        );


      const selectedSwatchValue =
        container?.querySelector(
          '[data-selected-value]'
        );


      if (
        selectedSwatchValue
      ) {
        selectedSwatchValue.innerHTML =
          value;
      }
    }
  }


  getInputForEventTarget(
    target
  ) {
    if (!target) {
      return null;
    }


    return target.tagName ===
      'SELECT'
      ? target.selectedOptions[0]
      : target;
  }


  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll(
        'select option[selected], fieldset input:checked'
      )
    ).map(
      ({ dataset }) =>
        dataset.optionValueId
    );
  }
}


if (
  !customElements.get(
    'variant-selects'
  )
) {
  customElements.define(
    'variant-selects',
    VariantSelects
  );
}


/* =========================================================
   PRODUCT RECOMMENDATIONS
========================================================= */

class ProductRecommendations extends HTMLElement {
  observer =
    undefined;


  constructor() {
    super();
  }


  connectedCallback() {
    this.initializeRecommendations(
      this.dataset.productId
    );
  }


  initializeRecommendations(
    productId
  ) {
    this.observer?.unobserve(
      this
    );


    this.observer =
      new IntersectionObserver(
        (
          entries,
          observer
        ) => {
          if (
            !entries[0]
              ?.isIntersecting
          ) {
            return;
          }


          observer.unobserve(
            this
          );


          this.loadRecommendations(
            productId
          );
        },
        {
          rootMargin:
            '0px 0px 400px 0px'
        }
      );


    this.observer.observe(
      this
    );
  }


  loadRecommendations(
    productId
  ) {
    if (!this.dataset.url) {
      return;
    }


    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
    )
      .then(
        (response) =>
          response.text()
      )
      .then((text) => {
        const html =
          document.createElement(
            'div'
          );


        html.innerHTML =
          text;


        const recommendations =
          html.querySelector(
            'product-recommendations'
          );


        if (
          recommendations?.innerHTML
            .trim().length
        ) {
          this.innerHTML =
            recommendations.innerHTML;
        }


        if (
          !this.querySelector(
            'slideshow-component'
          ) &&
          this.classList.contains(
            'complementary-products'
          )
        ) {
          this.remove();
        }


        if (
          html.querySelector(
            '.grid__item'
          )
        ) {
          this.classList.add(
            'product-recommendations--loaded'
          );
        }
      })
      .catch(
        (error) => {
          console.error(
            error
          );
        }
      );
  }
}


if (
  !customElements.get(
    'product-recommendations'
  )
) {
  customElements.define(
    'product-recommendations',
    ProductRecommendations
  );
}


/* =========================================================
   ACCOUNT ICON
========================================================= */

class AccountIcon extends HTMLElement {
  constructor() {
    super();


    this.icon =
      this.querySelector(
        '.icon'
      );
  }


  connectedCallback() {
    document.addEventListener(
      'storefront:signincompleted',
      this.handleStorefrontSignInCompleted.bind(
        this
      )
    );
  }


  handleStorefrontSignInCompleted(
    event
  ) {
    if (
      event?.detail?.avatar
    ) {
      this.icon?.replaceWith(
        event.detail.avatar.cloneNode()
      );
    }
  }
}


if (
  !customElements.get(
    'account-icon'
  )
) {
  customElements.define(
    'account-icon',
    AccountIcon
  );
}


/* =========================================================
   BULK ADD
========================================================= */

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY =
    250;


  constructor() {
    super();


    this.queue =
      [];


    this.setRequestStarted(
      false
    );


    this.ids =
      [];
  }


  startQueue(
    id,
    quantity
  ) {
    this.queue.push({
      id,
      quantity
    });


    const interval =
      setInterval(() => {
        if (
          this.queue.length > 0
        ) {
          if (
            !this.requestStarted
          ) {
            this.sendRequest(
              this.queue
            );
          }
        } else {
          clearInterval(
            interval
          );
        }
      }, BulkAdd.ASYNC_REQUEST_DELAY);
  }


  sendRequest(queue) {
    this.setRequestStarted(
      true
    );


    const items =
      {};


    queue.forEach(
      (queueItem) => {
        items[
          parseInt(
            queueItem.id
          )
        ] =
          queueItem.quantity;
      }
    );


    this.queue =
      this.queue.filter(
        (queueElement) =>
          !queue.includes(
            queueElement
          )
      );


    if (
      typeof this.updateMultipleQty ===
        'function'
    ) {
      this.updateMultipleQty(
        items
      );
    }
  }


  setRequestStarted(
    requestStarted
  ) {
    this._requestStarted =
      requestStarted;
  }


  get requestStarted() {
    return this._requestStarted;
  }


  getCartQuantityForLine(id) {
    const input =
      this.querySelector(
        `#Quantity-${id}`
      );


    return (
      parseInt(
        input?.dataset
          .cartQuantity ||
          input?.getAttribute(
            'value'
          ) ||
          '0',
        10
      ) || 0
    );
  }


  startCartLinesUpdate(items) {
    const {
      CartLinesUpdateEvent
    } =
      window.StandardEvents ||
      {};


    if (!CartLinesUpdateEvent) {
      return;
    }


    const linesByAction =
      Object.entries(
        items
      ).reduce(
        (
          groups,
          [
            variantId,
            quantity
          ]
        ) => {
          const nextQuantity =
            parseInt(
              quantity,
              10
            );


          const currentQuantity =
            this.getCartQuantityForLine(
              variantId
            );


          if (
            Number.isNaN(
              nextQuantity
            ) ||
            currentQuantity ===
              nextQuantity
          ) {
            return groups;
          }


          const action =
            currentQuantity === 0
              ? 'add'
              : nextQuantity === 0
              ? 'remove'
              : 'update';


          let line;


          if (
            action === 'add'
          ) {
            line = {
              merchandiseId:
                variantId,

              quantity:
                nextQuantity
            };
          } else {
            const lineKey =
              this.querySelector(
                `[data-quantity-variant-id="${variantId}"]`
              )?.dataset
                .quantityLineKey;


            if (!lineKey) {
              return groups;
            }


            line = {
              id:
                lineKey,

              quantity:
                nextQuantity
            };
          }


          if (
            !groups[action]
          ) {
            groups[action] =
              [];
          }


          groups[action].push(
            line
          );


          return groups;
        },
        {}
      );


    const deferreds =
      Object.entries(
        linesByAction
      ).map(
        ([action, lines]) => {
          const deferred =
            CartLinesUpdateEvent.createPromise();


          this.dispatchEvent(
            new CartLinesUpdateEvent({
              action,

              context:
                'product',

              lines,

              promise:
                deferred.promise
            })
          );


          return deferred;
        }
      );


    return {
      resolve:
        (parsedState) => {
          const payload = {
            cart:
              CartLinesUpdateEvent.createCartFromAjaxResponse(
                parsedState
              )
          };


          deferreds.forEach(
            (deferred) => {
              deferred.resolve(
                payload
              );
            }
          );
        },


      reject:
        (error) => {
          deferreds.forEach(
            (deferred) => {
              deferred.reject(
                error
              );
            }
          );
        }
    };
  }


  dispatchCartErrorEvent(
    message,
    code
  ) {
    const {
      CartErrorEvent
    } =
      window.StandardEvents ||
      {};


    if (!CartErrorEvent) {
      return;
    }


    this.dispatchEvent(
      new CartErrorEvent({
        error:
          message,

        code
      })
    );
  }


  resetQuantityInput(id) {
    const input =
      this.querySelector(
        `#Quantity-${id}`
      );


    if (!input) {
      return;
    }


    input.value =
      input.getAttribute(
        'value'
      );


    this.isEnterPressed =
      false;
  }


  setValidity(
    event,
    index,
    message
  ) {
    if (!event.target) {
      return;
    }


    event.target.setCustomValidity(
      message
    );


    event.target.reportValidity();


    this.resetQuantityInput(
      index
    );


    event.target.select();
  }


  validateQuantity(event) {
    if (!event.target) {
      return;
    }


    const inputValue =
      parseInt(
        event.target.value
      );


    const index =
      event.target.dataset
        .index;


    if (
      inputValue <
      Number(
        event.target.dataset
          .min
      )
    ) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings
          ?.min_error?.replace(
            '[min]',
            event.target.dataset
              .min
          ) ||
          'Quantity too low'
      );

    } else if (
      event.target.max &&
      inputValue >
        parseInt(
          event.target.max
        )
    ) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings
          ?.max_error?.replace(
            '[max]',
            event.target.max
          ) ||
          'Quantity too high'
      );

    } else if (
      event.target.step &&
      inputValue %
        parseInt(
          event.target.step
        ) !==
        0
    ) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings
          ?.step_error?.replace(
            '[step]',
            event.target.step
          ) ||
          'Invalid quantity'
      );

    } else {
      event.target.setCustomValidity(
        ''
      );


      event.target.reportValidity();


      event.target.setAttribute(
        'value',
        inputValue
      );


      this.startQueue(
        index,
        inputValue
      );
    }
  }


  getSectionInnerHTML(
    html,
    selector
  ) {
    if (
      !html ||
      !selector
    ) {
      return '';
    }


    const element =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        )
        .querySelector(
          selector
        );


    return element
      ? element.innerHTML
      : '';
  }
}


if (
  !customElements.get(
    'bulk-add'
  )
) {
  customElements.define(
    'bulk-add',
    BulkAdd
  );
}


/* =========================================================
   CART PERFORMANCE
========================================================= */

class CartPerformance {
  static #metric_prefix =
    'cart-performance';


  static createStartingMarker(
    benchmarkName
  ) {
    const metricName =
      `${CartPerformance.#metric_prefix}:${benchmarkName}`;


    return performance.mark(
      `${metricName}:start`
    );
  }


  static measureFromEvent(
    benchmarkName,
    event
  ) {
    const metricName =
      `${CartPerformance.#metric_prefix}:${benchmarkName}`;


    performance.mark(
      `${metricName}:start`,
      {
        startTime:
          event.timeStamp
      }
    );


    performance.mark(
      `${metricName}:end`
    );


    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }


  static measureFromMarker(
    benchmarkName,
    startMarker
  ) {
    if (!startMarker) {
      return;
    }


    const metricName =
      `${CartPerformance.#metric_prefix}:${benchmarkName}`;


    performance.mark(
      `${metricName}:end`
    );


    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }


  static measure(
    benchmarkName,
    callback
  ) {
    const metricName =
      `${CartPerformance.#metric_prefix}:${benchmarkName}`;


    performance.mark(
      `${metricName}:start`
    );


    if (
      typeof callback ===
      'function'
    ) {
      callback();
    }


    performance.mark(
      `${metricName}:end`
    );


    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}


console.info(
  'OUTLAWS global.js loaded successfully'
);